import styled from 'styled-components';

import { colors, fonts, fontSizes } from 'shared/defaultTheme';

export const CustomSelectWrapper = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: 1px solid ${colors.gullGrey};
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: auto;
  padding: 8px 10px;
  max-height: 375px;
  max-width: 320px;
  min-height: 40px;
  min-width: 127px;
  width: auto;
  font-family: ${fonts.medium};
  .text-container {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: auto;
  }
  &.open {
    flex-direction: column;
    padding-left: 0;
    padding-right: 0;
    position: absolute;
    top: 2.5rem;
    left: 1px;
    border: none;
    z-index: 3500;
    width: 100%;
    border-radius: 4px;
    background-color: ${colors.white};
    box-shadow: 0 2px 4px 0 ${colors.lightSilverTwo};
    overflow: auto;
    font-family: ${fonts.medium};
  }
  svg {
    fill: ${colors.black};
    height: 15px;
    width: 15px;
  }
  .default-text {
    color: rgba(0, 0, 0, 0.99);
    font-family: ${fonts.medium};
    font-size: ${fontSizes.xs}px;
    line-height: 15px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .item {
    background-color: ${colors.transparent};
    border: none !important;
    color: ${colors.suvaGrey};
    display: flex;
    font-family: ${fonts.medium};
    font-size: ${fontSizes.xs}px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    border-radius: 2px;
    line-height: 40px;
    padding: 0 !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
    width: 100%;
    &:hover {
      background-color: ${colors.whiteSmoke};
      color: ${colors.black};
    }
    &.selected {
      color: rgba(0, 0, 0, 0.99);
      font-family: ${fonts.medium};
      font-size: ${fontSizes.xs}px;
      line-height: 15px;
      &:hover {
        background-color: ${colors.transparent};
        color: ${colors.black};
      }
    }
  }
`;
